module.exports = __webpack_public_path__ + "static/tangled-5_ceramic-private-collection-e193b63ffe4abf066a7b3a620c77dd0a.jpg";